import React, { useState } from 'react';

function HoverImage({ defaultSrc, hoverSrc, alt, className }) {
  const [imageSrc, setImageSrc] = useState(defaultSrc);

  const handleMouseEnter = () => {
    setImageSrc(hoverSrc);
  };

  const handleMouseLeave = () => {
    setImageSrc(defaultSrc);
  };

  return (
    <button
      type="button"
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={imageSrc} alt={alt} />
    </button>
  );
}

export default HoverImage;
